// Portado del prototipo del Brain (`dont-merge-front-vision`), con su nombre
// y su codigo. Lo unico que cambia son los imports: alli vivian todos en un
// solo fichero de 2725 lineas.

import { FileText, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { FileInfo } from './types'

export function AttachmentCard({ file, removable, onRemove }: { file: FileInfo; removable?: boolean; onRemove?: () => void }) {
  return (
    <div className="group flex items-center gap-2 rounded-lg border bg-muted/30 px-3 py-2 text-xs transition-colors">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <FileText className="h-4 w-4 text-primary/70" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium text-foreground">{file.name}</div>
        <div className="text-muted-foreground">{file.size}</div>
      </div>
      {removable && onRemove && (
        <Button variant="link" onClick={onRemove} aria-label="Quitar" className="shrink-0 text-muted-foreground hover:text-foreground">
          <X className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  )
}

/* ─── KB Confirmation Card ──────────────────────────────── */
